import Styles from "./Chat.module.scss";
import clsx from "clsx";
import { useCallback, useMemo, useState } from "react";
import { BsChatText, BsEmojiSmile } from "react-icons/bs";
import PaginationComponent from "../../../Share/Component/Pagination";
import TableComponent from "../../../Share/Component/Table";
import {
  CHAT_FAKE_DATA,
  CHAT_STATUSES,
  CHAT_TABLE_COLUMNS,
  CHAT_TYPES,
} from "../../../Constants/chat";
import { formatDate } from "../../../Utils/index";

const PAGE_SIZE = 5;

function AdminChat() {
  const [search, setSearch] = useState("");
  const [keyword, setKeyword] = useState("");
  const [pageIndex, setPageIndex] = useState(0);

  const filteredChats = useMemo(() => {
    const normalizedKeyword = keyword.trim().toLowerCase();

    if (!normalizedKeyword) return CHAT_FAKE_DATA;

    return CHAT_FAKE_DATA.filter((chat) =>
      [
        chat.CharacterName,
        chat.Faction,
        chat.Type,
        chat.Content,
        chat.Status,
        String(chat.Level),
      ]
        .join(" ")
        .toLowerCase()
        .includes(normalizedKeyword)
    );
  }, [keyword]);

  const totalPages = Math.ceil(filteredChats.length / PAGE_SIZE);
  const safePageIndex = totalPages ? Math.min(pageIndex, totalPages - 1) : 0;

  const chats = useMemo(() => {
    const start = safePageIndex * PAGE_SIZE;

    return filteredChats.slice(start, start + PAGE_SIZE);
  }, [filteredChats, safePageIndex]);

  const paging = useMemo(
    () => ({
      next: safePageIndex < totalPages - 1,
      previous: safePageIndex > 0,
      totalPages,
      pageIndex: safePageIndex,
    }),
    [safePageIndex, totalPages]
  );

  const handleSearch = useCallback(() => {
    setKeyword(search);
    setPageIndex(0);
  }, [search]);

  const handleChangePage = useCallback((value) => {
    setPageIndex(value);
  }, []);

  return (
    <div className={clsx(Styles.main, "flex-grow-1")}>
      <div className={clsx(Styles.bodyMain, "container-fluid my-1")}>
        <div className={clsx(Styles.bodyMainTop)}>
          <div className={clsx(Styles.filterWrap)}>
            <div className={clsx(Styles.searchWrap)}>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className={clsx(Styles.Search)}
              />
              <span
                onClick={handleSearch}
                className={clsx(Styles.contentSearch)}
              >
                Search
              </span>
            </div>
          </div>
        </div>
        <div className={clsx(Styles.table)} id="style-3">
          <TableComponent
            data={chats}
            header={CHAT_TABLE_COLUMNS}
            customFormatters={{
              Type: (value) => {
                const isIcon = value === CHAT_TYPES.ICON;

                return (
                  <span
                    className={clsx(
                      Styles.typeBadge,
                      isIcon ? Styles.typeIcon : Styles.typeText
                    )}
                  >
                    {isIcon ? (
                      <BsEmojiSmile className={clsx(Styles.badgeIcon)} />
                    ) : (
                      <BsChatText className={clsx(Styles.badgeIcon)} />
                    )}
                    {value}
                  </span>
                );
              },
              Content: (value) => (
                <span className={clsx(Styles.contentCell)}>{value}</span>
              ),
              CreatedDate: formatDate,
              Status: (value) => (
                <span
                  className={clsx(
                    Styles.statusBadge,
                    value === CHAT_STATUSES.LOCK_ACCOUNT
                      ? Styles.statusLockAccount
                      : Styles.statusMuteChat
                  )}
                >
                  {value}
                </span>
              ),
            }}
          />
        </div>
        <div className={clsx(Styles.footer)}>
          <div className={clsx(Styles.footerWrap)}>
            <PaginationComponent
              page={paging}
              handleCallApi={handleChangePage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminChat;
